define('SuiteCommerce.ItemBadges.Collection', [
  'Backbone', 
  'Backbone.CachedCollection', 
  'SuiteCommerce.ItemBadges.Model', 
  'underscore', 
  'Utils'
], function ItemBadgesCollection(
  Backbone, 
  BackboneCachedCollection, 
  Model, 
  _, 
  Utils
) {
  'use strict';
  return BackboneCachedCollection.extend({
    model: Model,
    initialize() {
      this.url = Utils.getAbsoluteUrl(getExtensionAssetsPath('assets/services/ItemBadges.Service.ss'), true);
    },
    filterBadges: function filterBadges(badges) {
      var self = this;
      var itemBadges;
      var data;
      if (badges) {
        itemBadges = badges.split(',');
        _.each(itemBadges, function each(value, key) {
          itemBadges[key] = value.trim();
        });
        data = _.filter(self.models, function filter(badge) {
          return _.contains(itemBadges, badge.get('name').trim());
        });
      }
      return new Backbone.Collection(data);   
    },
  });
});
